import { render, staticRenderFns } from "./ChatFilesUploadButton.vue?vue&type=template&id=cbd1e556&scoped=true&"
import script from "./ChatFilesUploadButton.vue?vue&type=script&lang=js&"
export * from "./ChatFilesUploadButton.vue?vue&type=script&lang=js&"
import style0 from "./ChatFilesUploadButton.vue?vue&type=style&index=0&id=cbd1e556&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd1e556",
  null
  
)

export default component.exports